import BaseAPI from '@/apis/base/baseApi';
import httpClient from '../base/httpclient';
class AriseVoucherInformationApi extends BaseAPI {
  apiName = 'DI';
  controllerName = 'VoucherInformationArises';
}
export default new AriseVoucherInformationApi();
